var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"demo-page includes-toc"},[_c('toc',{attrs:{"sections":_vm.sections}}),_vm._l((_vm.sections),function({
      description,
      id,
      props: sectionProps,
      text,
    }){return _c('section',{key:id,attrs:{"id":id}},[_c('h2',[_vm._v(_vm._s(text))]),_c('p',[_vm._v(_vm._s(description))]),_c('RfpTable',_vm._b({},'RfpTable',{ ...sectionProps },false))],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }